module.exports = __webpack_public_path__ + "img/water-level-new4.2a42ab83.gif";